<template>
  <div>
    <!-- <meta name="viewport" content="width=device-width,initial-scale=1.0" /> -->
    <sub-head subTitle="멀티 게임" subImg="game_top" class="web"></sub-head>
    <div class="page_padding">
      <bread-crumb :path="$route" class="bread"></bread-crumb>
    </div>

    <div class="main-page">
      <div v-if="summary" class="summary" style="padding-top: 90px">
        <h2 v-html="summary.h"></h2>
        <p style="margin-top: 40px" v-html="summary.p"></p>
        <image-component
          style="padding-top: 40px; max-width: 918px;"
          path="multi/multi_image01.png"
        ></image-component>
        <div
          class="flex"
          style="justify-content: center; margin-top: 40px; gap: 16px; max-width: 920px;"
        >
          <image-component
            style="max-width: 296px;"
            path="multi/multi_image02.png"
          ></image-component>
          <image-component
            style="max-width: 296px;"
            path="multi/multi_image03.png"
          ></image-component>
          <image-component
            style="max-width: 296px;"
            path="multi/multi_image04.png"
          ></image-component>
        </div>
        <p style="margin-top: 58px; margin-bottom: 118px;">
          {{ summaryFooter }}
        </p>
      </div>

      <div v-if="howto" class="howto" style="padding-top: 162px">
        <h1 v-html="howto.h"></h1>
        <p style="margin-top: 40px" v-html="howto.p"></p>
        <div
          v-if="howtoList"
          class="flex"
          style="margin-top: 80px; flex-direction: column; gap: 40px;"
        >
          <div
            class="flex"
            style="justify-content: center; align-content: center; gap: 40px 30px; padding: 34px 60px;"
            v-for="(obj, index) in howtoList"
            :key="index + obj.title"
          >
            <image-component
              style="flex-grow: 0;"
              :path="obj.imgPath"
            ></image-component>
            <div style="text-align: left; flex-grow: 1;">
              <h4 style="margin-top: 30px;">
                {{ obj.title }}
              </h4>
              <p
                style="margin-top: 20px; font-size: 1.0rem; line-height: 1.875rem;"
              >
                {{ obj.content }}
              </p>
              <p v-if="obj.extra" class="endnotes" style="margin-top: 40px;">
                {{ obj.extra }}
              </p>
            </div>
          </div>
        </div>
        <div style="padding-top: 187px;"></div>
      </div>

      <div v-if="tabletInfo" class="tabletInfo" style="padding-top: 115px">
        <h1 v-html="tabletInfo.h"></h1>
        <p style="margin-top: 40px;" v-html="tabletInfo.p"></p>
        <image-component
          style="margin-top: 85px; margin-bottom: 205px;"
          :path="tabletInfo.imgPath"
        />
      </div>
    </div>
  </div>
</template>

<script>
import ImageComponent from "@/components/imageComponent.vue";
import subHead from "@/components/sub_head.vue";
import BreadCrumb from "@/components/BreadCrumb.vue";

// import Tab from "@/components/Tab.vue";
export default {
  components: {subHead, ImageComponent, BreadCrumb},

  data() {
    return {
      summary: {
        h:
          "해피테이블 vs 해피테이블<br />온라인에서 만나는 <b>'해피테이블 멀티게임'</b>",
        p: "해피테이블의 최강자는 누구일까? 숨은 강자를 찾아라!",
      },
      summaryFooter:
        "3가지 게임을 통해 해피테이블 인지게임의 최강자가 되어보자",
      howto: {
        h: "게임 방법",
      },
      howtoList: [
        {
          title: "사용자 선택",
          content:
            "게임에 참여할 사용자를 선택합니다.\n여러명이 로그인 되어있으면 그 중 1명의 사용자만 진행 가능합니다.",
          imgPath: "multi/multi_image05.png",
        },
        {
          title: "사용자 찾기",
          content:
            "사용자를 선택하시고 잠시 기다리시면 전국 팔도의 해피테이블 사용자들과 매칭됩니다.",
          imgPath: "multi/multi_image06.png",
        },
        {
          title: "매치 완료",
          content:
            "정정당당하게 실력을 겨뤄 해피테이블 세계에서 고수로 이름을 알리세요!",
          imgPath: "multi/multi_image07.png",
          extra:
            "※실제 사용자들과의 매칭이기 때문에 시간이 오래걸리거나 매칭이 되지 않을 수 있습니다",
        },
      ],
      tabletInfo: {
        h: "<b>'태블릿용'</b> 해피테이블 멀티게임 제공",
        p:
          "해피테이블이 설치되어 있는 기관은 태블릿용 멀티게임 프로그램을 추가제공",
        imgPath: "multi/multi_image08.png",
      },
    };
  },
};
</script>

<style scoped>
h1,
h2,
h3,
h4,
h5,
h6 {
  word-break: keep-all;
  word-wrap: break-word;
}
h1 {
  font-size: 2.5rem;
  font-weight: 800;
  line-height: 3.75rem;
  color: #0a0a0a;
}

h2 {
  font-size: 2.125rem;
  font-weight: bold;
  line-height: 3.75rem;
  letter-spacing: -0.064rem;
  color: #878282;
}

h4 {
  font-size: 1.375rem;
  line-height: 1.688rem;
  font-weight: 800;
  color: #1c1c1c;
}

h5 {
  font-size: 1.25rem;
  line-height: 2.75rem;
  font-weight: 800;
  color: #1c1c1c;
}

.main-page ::v-deep b {
  color: #ff5230;
}
.main-page ::v-deep u {
  text-decoration: unset;
  border-bottom: 2px solid #ff5230;
}

p {
  font-size: 1.125rem;
  font-weight: 500;
  color: #5a5a5a;
  line-height: 2.375rem;
  word-break: keep-all;
  word-wrap: break-word;
  white-space: pre-line;
}

hr {
  border: 1px solid #0a0a0a;
}

table {
  border-collapse: collapse;
}

th,
td {
  border-top: 1px solid #707070;
  border-bottom: 1px solid #707070;
  padding: 18px 20px;
}

td {
  color: #5a5a5a;
  text-align: left;
}

th {
  background-color: #f6f6f6;
  color: #1c1c1c;
}

/* TODO: because of mulfunction of image width v-deep is used, need to fix. */
::v-deep img {
  width: unset !important;
  max-width: 100%;
}

.main-page > div > * {
  max-width: 1200px;
  margin: auto;
  padding: 0 20px;
}

.main-page > div:nth-child(even) {
  background-color: #f6efe8;
}

/* .main-page > div:nth-child(odd) {} */

.flex {
  display: flex;
  flex-wrap: wrap;
  gap: 60px 30px;
}

.flex > * {
  flex: 1 1 auto;
}

.flex p {
  font-size: 0.875rem;
  line-height: 1.5rem;
  margin: auto;
}

.spec {
  background: none !important;
}

.endnotes {
  font-size: 0.875rem;
  font-weight: 500;
  color: #ff5d3d;
}

.circle-bg {
  background: #f6f6f6;
  border-radius: 50%;
  width: 180px;
  height: 180px;
  margin: auto;
  padding: 39px;
  box-sizing: border-box;
}

.scenario-item {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  max-width: 234px;
  height: 334px;

  border: 2px solid #e4e4e4;
  padding-top: 57px;
  box-sizing: border-box;
}

.howto .flex .flex {
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #5e331529;
}

@media (max-width: 767px) {
  .banner.web {
    margin-top: 60px;
    .banner-title {
      font-size: 1.5rem;
    }
  }

  h1 {
    font-size: 1.5rem;
    line-height: 2rem;
  }
  h2 {
    font-size: 1.4rem;
    line-height: 1.8rem;
  }
}
</style>
